<template>
  <v-dialog v-model="showForm" max-width="600px">
    <v-card>
      <v-card-title class="headline">
        Registrar pago con {{ title }}
      </v-card-title>
      <validation-observer v-slot="{ handleSubmit }" ref="formPago">
        <form id="formPago" @submit.prevent="handleSubmit(validateForm)">
          <v-card-text>
            <!-- Cheque -->
            <v-row v-if="metodoPago.cheque_sn === 1">
              <v-col cols="5" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="banco" rules="required">
                  <v-select v-model="nuevoCheque.banco" color="gold" :items="bancos" label="Banco" :error-messages="errors" return-object item-text="descripcion">
                    <template v-slot:item="{ attrs, item, on }">
                      <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.descripcion" />
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </v-col>
              <v-col cols="7" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="número de cheque" rules="max:8|required">
                  <v-text-field v-model="nuevoCheque.numero" color="gold" :error-messages="errors" type="number" autocomplete="off" label="Número de cheque" />
                </validation-provider>
              </v-col>
              <v-col cols="8" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="emisor" rules="max:45|required">
                  <v-text-field v-model="nuevoCheque.emisor" color="gold" :error-messages="errors" label="Emisor" />
                </validation-provider>
              </v-col>
              <v-col cols="4" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="importe" rules="required">
                  <v-text-field v-model="nuevoPago.totalAPagar" color="gold" :error-messages="errors" type="number" step="0.01" :prefix="moneda" label="Importe" />
                </validation-provider>
              </v-col>
              <v-col v-if="cobro" cols="6" class="pt-1 pb-1">
                <v-menu ref="menuFechaCR" v-model="menuFechaCR" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <validation-provider v-slot="{ errors }" name="Fecha recibido" rules="required">
                      <v-text-field v-model="nuevoCheque.fecha_recibido" color="gold" :error-messages="errors" label="Fecha recibido" readonly v-on="on" />
                    </validation-provider>
                  </template>
                  <v-date-picker v-model="nuevoCheque.fecha_recibido" color="gold" landscape scrollable locale="es-419" no-title @input="menuFechaCR = false" />
                </v-menu>
              </v-col>
              <v-col  v-if="cobro" cols="6" class="pt-1 pb-1">
                <v-menu ref="menuFechaCobro" v-model="menuFechaCobro" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <validation-provider v-slot="{ errors }" name="Fecha cobro" rules="required">
                      <v-text-field v-model="nuevoCheque.fecha_cobro" color="gold" :error-messages="errors" label="Fecha cobro" readonly v-on="on" />
                    </validation-provider>
                  </template>
                  <v-date-picker v-model="nuevoCheque.fecha_cobro" color="gold" landscape scrollable locale="es-419" no-title @input="menuFechaCobro = false" />
                </v-menu>
              </v-col>
            </v-row>
            <!-- transferencia bancaria -->
            <v-row v-else-if="metodoPago.cta_bancaria_sn === 1">
              <v-col cols="6" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="cuenta" rules="required">
                  <v-select v-model="ctaBcaSelected" color="gold" :error-messages="errors" :items="cuentasBancarias" label="Elegir existente" return-object item-text="descripcion">
                    <template v-slot:item="{ attrs, item, on }">
                      <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.descripcion" />
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="emisor" rules="required">
                  <v-text-field v-model="nuevoPago.totalAPagar" color="gold" :error-messages="errors" type="number" step="0.01" :prefix="moneda" label="Importe" />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- tarjeta -->
            <v-row v-else-if="metodoPago.descripcion === 'Tarjeta'">
              <v-col cols="6" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="tarjeta" rules="required">
                  <v-select v-model="tarjetaSelected" color="gold" :error-messages="errors" :items="tarjetas" label="Elegir existente" return-object item-text="numero">
                    <template v-slot:item="{ attrs, item, on }">
                      <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.numero" />
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </validation-provider>
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <v-text-field v-model="nombreBancoTarjeta" color="gold" readonly label="Banco" />
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="cuotas" rules="required">
                  <v-text-field v-model="nuevoPago.cuotas" color="gold" :error-messages="errors" type="number" step="1" label="Cuotas" />
                </validation-provider>
              </v-col>
              <v-col cols="6" class="pt-1 pb-1">
                <validation-provider v-slot="{ errors }" name="emisor" rules="required">
                  <v-text-field v-model="nuevoPago.totalAPagar" color="gold" :error-messages="errors" type="number" step="0.01" :prefix="moneda" label="Importe" />
                </validation-provider>
              </v-col>
            </v-row>
            <!-- efectivo -->
            <v-row v-else>
              <v-col class="pt-1 pb-1 pl-8">
                <validation-provider v-slot="{ errors }" name="emisor" rules="required">
                  <v-text-field v-model="nuevoPago.totalAPagar" color="gold" :error-messages="errors" type="number" step="0.01" :prefix="moneda" label="Importe" />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text type="submit">
              Aceptar
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </form>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'RegistroPagos',
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      cobro: {
        type: Boolean,
        default: false,
      },
      totalRestante: {
        type: Number,
        default: 0,
      },
      metodoPago: {
        type: Object,
        default: null,
      },
      moneda: {
        type: String,
        default: '$',
      },
      title: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        nuevoCheque: {},
        nuevoPago: {},
        ctaBcaSelected: null,
        menuFechaCobro: false,
        menuFechaCR: false,
        showForm: false,
        bancos: [],
        cuentasBancarias: [],
        tarjetas: [],
        tarjetaSelected: null,
      }
    },
    computed: {
      nombreBancoTarjeta () {
        return (this.tarjetaSelected) ? this.tarjetaSelected.banco.descripcion : ''
      },
    },
    watch: {
      totalRestante () {
        this.nuevoPago.totalAPagar = this.totalRestante
      },
      show () {
        this.showForm = this.show
      },
      showForm () {
        this.$emit('closeDialog', this.showForm)
      },
    },
    created () {
      this.inicAll()
      this.updateBancos()
      this.updateCuentasBancarias()
      this.getTarjetas()
    },
    methods: {
      generarPago () {
        if (this.totalRestante - this.nuevoPago.totalAPagar < 0) {
          this.$store.commit('toast/show', { tipo: 'error', messages: ['El monto a cubrir no puede superar el total restante'] })
          return
        }
        this.nuevoPago.metodopago = this.metodoPago
        this.nuevoPago.montoACubrir = parseFloat(this.nuevoPago.totalAPagar)
        if (this.metodoPago.cheque_sn) {
          this.nuevoPago.elementoPago = this.nuevoCheque
        } else if (this.metodoPago.cta_bancaria_sn) {
          this.nuevoPago.elementoPago = this.ctaBcaSelected
        } else if (this.metodoPago.descripcion === 'Tarjeta') {
          this.nuevoPago.elementoPago = this.tarjetaSelected
        }
      },
      inicAll () {
        this.nuevoCheque = {
          banco: null,
          numero: '',
          emisor: '',
        }
        this.nuevoPago = {
          totalAPagar: 0,
          montoACubrir: 0,
          elementoPago: null,
        }
        this.ctaBcaSelected = null
        this.tarjetaSelected = null
      },
      updateBancos () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/banco_get/' }).then(response => { this.bancos = response })
      },
      updateCuentasBancarias: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/cuenta_bancaria_propias/' }).then(response => { this.cuentasBancarias = response })
      },
      getTarjetas () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tarjeta_get/' }).then(response => { this.tarjetas = response })
      },
      validateForm (scope) {
        this.generarPago()
        this.$emit('pagoGenerado', this.nuevoPago)
        this.inicAll()
        this.$nextTick(() => {
          this.$refs.formPago.reset()
        })
      },
    },
  }
</script>
